import type { GetPresetsResponse } from '@/api/types';
import API from '@api/API';
import { ENDPOINTS } from '../endpoints';

export const presetsApi = {
  getPresets: async (): Promise<GetPresetsResponse> => {
    const res = await API().get<GetPresetsResponse>(ENDPOINTS.presets.list());
    return res.data;
  },
};
